import axiosInstance from "../utils/api";
import endpoints from "../constants/endpoints";



export const getListOfProductTemplates = async () => {
    try {
        const response = await axiosInstance.get(`${endpoints.fetchListOfProductTemplates}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch product templates: ' + error.message);
    }
}

export const searchAndFilterTemplates = async (searchTerm, category, subCategory, status) => {
    try {
        const response = await axiosInstance.get(`${endpoints.searchAndFilterTemplates(searchTerm, category, subCategory, status)}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to search and filter templates: ' + error.message);
    }
}

export const getCategoriesAndSubcategories = async () => {
    try {
        const response = await axiosInstance.get(`${endpoints.fetchCategoriesAndSubcategories}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch categories and subcategories: ' + error.message);
    }
}
export const getSingleTemplate = async (templateId) => {
    try {
        const response = await axiosInstance.get(`${endpoints.getSingleTemplateDetail(templateId)}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch single template: ' + error.message);
    }
}

export const createProductTemplate = async (templateData) => {
    try {
        const response = await axiosInstance.post(`${endpoints.createTemplate}`, templateData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error('Failed to create product template: ' + error.message);
    }
}

export const updateProductTemplate = async (templateId, templateData) => {
    try {
        const response = await axiosInstance.put(`${endpoints.updateTemplate(templateId)}`, templateData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },

            });
        return response.data;
    } catch (error) {
        throw new Error('Failed to update product template: ' + error.message);
    }
}


export const deleteTemplatesAdmin = async (templateIds) => {
    try {
        const response = await axiosInstance.delete(`${endpoints.deleteTemplates}`, {

            data: { templates_ids: templateIds },
        });
        return response.data;
    } catch (error) {

        throw error;
    }
};





